module.exports = __webpack_public_path__ + "static/img/banner.210290bf.jpg";